export default {
    sbl_login_response: null
}


// WEBPACK FOOTER //
// ./src/reducers/initialState.js